import ApiService, { HTTPMethod } from './api.core'
import { Motorcycle } from '../models/Motorcycle'

export class MotocyclesApi {
  static async getModelYears() {
    let resp = await ApiService.fetch('motorcycles/years')
    if (resp.ok) {
      resp.parsedData = resp.data
    }
    return resp
  }

  static async getMakes(year: number) {
    let resp = await ApiService.fetch(`motorcycles/makes${year ? `?year=${year}` : ''}`)
    if (resp.ok) {
      resp.parsedData = resp.data
    }
    return resp
  }

  static async getModels(make, year) {
    let resp = await ApiService.fetch(`motorcycles/models?year=${year}&make=${make}`)
    if (resp.ok) {
      resp.parsedData = resp.data
    }
    return resp
  }

  static async getRequestedMotorcycle(model, year) {
    let resp = await ApiService.fetch(`motorcycles/get_requested_motorcycle?year=${year}&model=${model}`)
    if (resp.ok) {
      resp.parsedData = resp.data
    }
    return resp
  }

  static async addNewMotorcycle(newMotorcycle: Motorcycle) {
    let resp = await ApiService.fetch('motorcycles/addMotorcycle', HTTPMethod.POST, {
      year: newMotorcycle.year,
      make: newMotorcycle.make.toUpperCase(),
      model: newMotorcycle.model.toUpperCase(),
      symbol: newMotorcycle.symbol,
      progressive_symbol: newMotorcycle.progressiveSymbol,
      engine_cc: newMotorcycle.engineCC,
      value: newMotorcycle.value,
      base_miles_group: newMotorcycle.baseMilesGroup,
      type: newMotorcycle.type,
    })
    if (resp.ok) {
      resp.parsedData = resp.data
    }
    return resp
  }
}
